<template>
  <div class="modaldata">
    <div class="modal fade" :id="application_id">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title pull-left">
              <span>{{ header }}</span>
              <span class="text-danger text-center h6">
                ( กรุณาอัปโหลดเอกสารเป็นไฟล์ pdf ที่ขนาดไม่เกิน 20 MB )</span
              >
            </h4>
          </div>
          <div class="modal-body">
            <div v-if="typeModal == 'upload'">
              <div class="row">
                <div class="col-md-12 m-b">
                  <h5 class="pull-left m-l-lg">upload เลขใบคำขอ : {{ application_id }}</h5>
                </div>
                <div class="col-md-12 b-r">
                  <div class="form-group col-md-12 clear">
                    <label class="col-md-4 col-sm-12 clear m-t-xs control-label">
                      <i class="fas fa-clipboard"></i> ใบคำขอเอาประกันภัย
                    </label>
                    <div class="col-md-3 col-sm-12 m-t-xs">
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        accept="application/pdf"
                        v-on:change="handleFileUploads1()"
                        style="z-index: 99999 !important;position: absolute !important;"
                      />
                    </div>
                    <div class="col-md-4 col-sm-12 m-t-xs">
                      <button
                        class="btn btn-sm btn-success pull-right text-uc m-t-n-xs"
                        v-on:click="submitFiles1()"
                        :disabled="disabled_upload"
                      >
                        <strong>UPLOAD FILE</strong>
                      </button>
                    </div>
                  </div>

                  <!-- OLD upload bill pay ment
                        <div class="form-group col-sm-12 m-t">
                            <label class="col-sm-4 control-label"><i class="fas fa-file-alt"></i> เอกสาร bill payment</label>
                            <div class="col-sm-3">
                                <input type="file" id="file2" ref="file2"
                                class="filestyle"
                                data-icon="false"
                                data-classbutton="btn btn-default"
                                data-classinput="form-control inline input-s"
                                v-on:change="handleFileUploads2()">
                            </div>
                            <div class="col-sm-4">
                                <button class="btn btn-sm btn-success pull-right text-uc m-t-n-xs"
                                v-on:click="submitFiles2()"
                                :disabled="disabled_upload_bill"
                                ><strong>UPLOAD FILE</strong></button>
                            </div>
                  </div>-->

                  <div
                    class="form-group col-md-12 m-t-lg"
                    style="margin-top:40px; border-top:1px solid #ccc;"
                  >
                    <div class="form-group m-t-md">
                      <button
                        class="btn btn-sm btn-dark pull-right text-uc m-t-n-xs"
                        data-dismiss="modal"
                      >
                        <strong>CLOSE</strong>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'modaldata',
  props: ['header', 'status', 'typeModal', 'application_id', 'backoffice'],
  data() {
    return {
      is_modal_amlo: null,
      disabled_upload: true,
      disabled_upload_bill: true,
      file1: null,
      file2: null,
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(['env']),
  },
  components: {},
  methods: {
    ...mapActions(['api_upload_file_app', 'api_upload_file_bill_app']),
    closeModal() {
      $('#modal-status-form').modal('hide')
    },
    handleFileUploads1() {
      this.file1 = this.$refs.file.files[0]
      //console.log('file1',this.file1)
      this.disabled_upload = false
    },
    handleFileUploads2() {
      this.file2 = this.$refs.file2.files[0]
      //console.log('file2',this.file2)
      this.disabled_upload_bill = false
    },
    submitFiles1() {
      //alert('submit1')
      let data = {
        application_id: this.application_id,
        name: 'file',
        filename: this.file1,
        backoffice:
          typeof this.backoffice == 'undefined' || this.backoffice == null
            ? false
            : this.backoffice,
      }
      this.api_upload_file_app(data)
    },
    submitFiles2() {
      //alert('submit2')
      let data = {
        application_id: this.application_id,
        name: 'file',
        filename: this.file2,
      }
      this.api_upload_file_bill_app(data)
    },
  },
}
</script>

<style lang="scss"></style>
